@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Integrações</div>
        </div>
      </div>
    </div>
    <div class="pt-3 pr-4 pb-4 pl-4">
      <!-- Dados -->
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                <th class="tabela_borda">Nome</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *cdkVirtualFor="let integracao of integracoes; templateCacheSize: 0;">
                @if (is_master || is_diretor || integracao.ver_todos) {
                  <tr>
                    <td class="text-center tabela_acao">
                      <i class="fa fa-play btn_tabela_acao" placement="right" ngbTooltip="Executar" (click)="iniciarIntegracao(integracao.token, integracao.url_integracao, integracao.url_webjob)"></i>
                    </td>
                    <td class="tabela_borda">{{ integracao.nome_integracao }}</td>
                  </tr>
                }
              </ng-container>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
}
